/**
 * API Constants
 *
 * Centralized configuration for API timeouts and other constants.
 */

/**
 * API request timeouts in milliseconds
 *
 * These values are tuned for different operation types:
 * - Quick operations (user lookups): 30-45 seconds
 * - Standard operations (content loading): 60 seconds
 * - Heavy operations (exports, diagnostics): 2-5 minutes
 */
export const API_TIMEOUTS = {
  /** Default timeout for standard API calls (30 seconds) */
  DEFAULT: 30_000,

  /** Timeout for loading user profiles (45 seconds) */
  PROFILE_LOAD: 45_000,

  /** Timeout for loading user content like trainings, stories (60 seconds) */
  CONTENT_LOAD: 60_000,

  /** Timeout for email/data exports (2 minutes) */
  EXPORT: 120_000,

  /** Timeout for profile diagnostics scans (3 minutes) */
  DIAGNOSTICS: 180_000,

  /** Timeout for full database scans like orphan detection (5 minutes) */
  FULL_SCAN: 300_000,
} as const;

/**
 * Type for timeout keys
 */
export type ApiTimeoutKey = keyof typeof API_TIMEOUTS;
